// extracted by mini-css-extract-plugin
export default {"cardBlock":"PassengerCard_cardBlock__5uWhF"};